module.exports = __webpack_public_path__ + "img/hair.19ec2148.png";